import { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { Routes, Route, Link, useLocation } from 'react-router-dom'

import { Home, Smartphone, Zap, Menu, HelpCircle } from 'lucide-react'
import HomePage from './pages/home.page'
import QuizPage from './pages/quiz.page'
import { LanguageProvider } from './contexts/LanguageContext'
import LoadingPage from './pages/loading.page'
import ProcessResultPage from './pages/process-result.page'
import ResultPage from './pages/result.page'
import ReportPage from './pages/report.page'
import ThankYouPage from './pages/thank-you.page'
import ResultTestPage from './pages/result-test.page'
import { useGA4PageTracking } from './hooks/useGA4'


const App = () => {
  const [showMenu, setShowMenu] = useState(false)
  const location = useLocation()
  
  // Track page views automatically
  useGA4PageTracking()

  const pages = [
    { path: '/', label: 'Design System', icon: <Home className="w-4 h-4" /> },

  ]

  const isActiveRoute = (path: string) => {
    return location.pathname === path
  }

  return (
    <LanguageProvider>
      <AnimatePresence mode="wait">
        <motion.div
         
        >
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/quiz" element={<QuizPage />} />
            <Route path="/loading" element={<LoadingPage />} />
            <Route path="/processing-result" element={<ProcessResultPage />} />
            <Route path="/result" element={<ResultPage />} />
            <Route path="/report/:reportId" element={<ReportPage />} />
            <Route path="/result-test" element={<ResultTestPage />} />
            <Route path="/thank-you" element={<ThankYouPage />} />
          </Routes>
        </motion.div>
      </AnimatePresence>
    </LanguageProvider>
  )
}

export default App